/**
 * Round number to specified decimal numbers. default: 2
 * round(1.005) === 1.01
 * @param value number to round
 * @param decimals decimal places
 */
const round = (value: number, decimals = 2): number => {
  const valueTo7Decimals = value.toFixed(7);
  // @ts-ignore typescript doesn't like mixing numbers and strings
  return +`${Math.round(`${valueTo7Decimals}e+${decimals}`)}e-${decimals}`;
};

const sortBy = <T>(items: T[], key = 'DisplayOrder', orderAsc = true): T[] =>
  orderAsc ? sortByAsc(items, key) : sortByDesc(items, key);

const sortByAsc = <T>(items: T[], key = 'DisplayOrder') =>
  [...items].sort((a, b) => {
    if (a[key] < b[key]) return -1;
    if (a[key] > b[key]) return 1;
    return 0;
  });

const sortByDesc = <T>(items: T[], key = 'DisplayOrder'): T[] =>
  [...items].sort((a, b) => {
    if (a[key] < b[key]) return 1;
    if (a[key] > b[key]) return -1;
    return 0;
  });

const stringToNumber = (val: string | number): number =>
  typeof val === 'string' ? parseInt(val) : val;

export const changeUtils = {
  round,
  sortBy,
  sortByAsc,
  sortByDesc,
  stringToNumber,
};
